<template>
  <div class="advance-reporting-popup">
    <div class="popup-content">
      <div class="section">
        <div v-if="rowItem" class="row-details mb-4">
          <div class="detail-item">
            <span class="detail-label">Format:</span>
            <span class="detail-value">{{ formatValue }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Start Date:</span>
            <span class="detail-value">{{ startDateValue }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">End Date:</span>
            <span class="detail-value">{{ endDateValue }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Status:</span>
            <span class="detail-value">{{ statusValue }}</span>
          </div>
        </div>
        <div class="names-list">
          <div v-for="(name, index) in names" :key="index" class="name-item">
            {{ name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone"
import { computed } from "vue"

export default {
  name: "NamesListPopUp",
  props: {
    title: {
      type: String,
      required: true,
      default: "Items"
    },
    names: {
      type: Array,
      required: true,
      default: () => []
    },
    rowItem: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    const formatValue = computed(() => {
      if (!props.rowItem?.format) return "—"
      return String(props.rowItem.format).toUpperCase()
    })

    const startDateValue = computed(() => {
      if (!props.rowItem?.start_date) return "—"
      const date = moment(props.rowItem.start_date)
      if (!date.isValid()) return props.rowItem.start_date
      return date.format("MMMM D, YYYY")
    })

    const endDateValue = computed(() => {
      if (!props.rowItem?.end_date) return "—"
      const date = moment(props.rowItem.end_date)
      if (!date.isValid()) return props.rowItem.end_date
      return date.format("MMMM D, YYYY")
    })

    const statusValue = computed(() => {
      return props.rowItem?.scheduler_status || "—"
    })

    return {
      formatValue,
      startDateValue,
      endDateValue,
      statusValue
    }
  }
}
</script>
